import { render, staticRenderFns } from "./zhej.vue?vue&type=template&id=fac6cbe4&"
import script from "./zhej.vue?vue&type=script&lang=js&"
export * from "./zhej.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports